import FileApprovalList from "./fileApprovalList";

/**
 * Returns the Large File Approval page component.
 * 
 * @returns The Large File Approval page component.
 */
const LargeFileApproval = () => {
    return (
        <>
            <div className="flex flex-col h-fit">

                <FileApprovalList />
            </div>
        </>
    );
};

export default LargeFileApproval;